/* jshint camelcase: false */
define('models/base/model',['require','underscore','chaplin','config/application','config/environment','lib/utils','mediator','mediator'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        applicationConfig = require('config/application'),
        environmentConfig = require('config/environment'),
        utils = require('lib/utils');

    var Model = Chaplin.Model.extend({
        /**
         * Api root property
         *
         * @property apiRoot
         * @type {string}
         */
        apiRoot: environmentConfig[applicationConfig.environment].api.root,
        /**
         * Url path for crud will throw error if undefined so
         * it should be overridden
         *
         * @property urlPath
         * @type {string}
         */
        urlPath: '',
        /**
         * Will gather additional params before request
         *
         * @method urlParams
         */
        urlParams: function() {
            var params = {};
            //     accessToken,
            //     mediator;

            // mediator = require('mediator');
            // if (mediator.user) {
            //     accessToken = mediator.user.get('accessToken');
            // }

            // if (accessToken) {
            //     params.access_token = accessToken;
            // }

            return params;
        },
        /**
         * Will build url root
         *
         * @method urlRoot
         */
        urlRoot: function() {
            var urlPath = _.isFunction(this.urlPath) ? this.urlPath() : this.urlPath;

            if (urlPath) {
                return this.apiRoot + urlPath;
            } else {
                throw new Error('Model must redefine urlPath');
            }
        },
        /**
         * Extends from lib/utils ajax method but
         * before modify url
         *
         * @method ajax
         * @return {Deferred} to manipulate with request
         */
        ajax: function(url) {
            var args = arguments,
                fullUrl = this.apiRoot + url;

            args[0] = fullUrl;
            // TODO: add access token to headers

            return utils.ajax.apply(this, args);
        },
        /**
         * Modified url based on params and url root
         *
         * @method url
         * @return {string} modified url
         * @see Backbone.url()
         */
        url: function() {
            var full = this.urlRoot(),
                payload = utils.queryParams.stringify(this.urlParams()),
                sep,
                url;

            if (payload) {
                sep = (full.indexOf('?') >= 0) ? '&' : '?';
                url = full + sep + payload;
            } else {
                url = full;
            }

            return url;
        },

        updateInterval: 0,
        timerEnabled: false,

        constructor: function() {
            Chaplin.Model.apply(this, arguments);
            if (this.timerEnabled) {
                this.timerUpdate();
            }
        },

        timerUpdate: function() {
            if (this.get('loading')) { return; }

            if (this._updateTimeout) {
                clearTimeout(this._updateTimeout);
                delete this._updateTimeout;
            }

            if (this.disposed) { return; }

            var _this = this;

            if (this.updateInterval && this.timerEnabled) {
                this.once('afterLoad', function() {
                    this._updateTimeout = setTimeout(function() {
                        _this.timerUpdate();
                    }, this.updateInterval);
                });
                this.load();
            }
        },

        dispose: function() {
            if (this.disposed) {
                return;
            }
            if (this._updateTimeout) {
                clearTimeout(this._updateTimeout);
                delete this._updateTimeout;
            }
            if (this.__request) {
                this.__request.abort();
                delete this.__request;
            }
            Chaplin.Model.prototype.dispose.apply(this, arguments);
        },

        disposeSubModels: function() {
            var key, prop, keys = _.keys(this);

            for (var i=0, li=keys.length; i>li; i++) {
                prop = this[key];
                if (prop && typeof prop.dispose === 'function') {
                    prop.dispose();
                    delete this[key];
                }
            }
        },

        load: function(startController) {
            var _this = this;
            var mediator = require('mediator');

            if (this.__request) { this.__request.abort(); }
            this.set('loading', true);

            if (startController) { mediator.publish('controller:actionStart'); }

            this.trigger('beforeLoad');
            this.__request = this.fetch();
            this.__request.complete(function() {
                _this.set('loading', false);
                _this.trigger('afterLoad');
                if (startController) { mediator.publish('controller:actionDone'); }
            });

            return this.__request;
        },

        sync: function(method, model, options) {
            var _this = this,
                completeFn,
                mediator = require('mediator'),
                action = this.action;

            if (action) {
                mediator.channel.send(action, this.urlParams(), function(err, res) {
                    if (err) { options.error(err); }
                    if (res) { options.success(res); }
                    if (completeFn) { completeFn.apply(_this, arguments); }
                });

                return {
                    complete: function(fn) {
                        completeFn = fn;
                    }
                };
            } else {
                return Chaplin.Model.prototype.sync.apply(this, arguments);
            }
        }
    });

    return Model;
});

